import React from 'react'

import { setIsFaqModalOpen } from '../../store/ui/uiSlice'
import Heading from '../Heading/Heading'
import Modal from '../Modal/Modal'
import * as Styled from './styles'
import { useAppDispatch, useAppSelector } from '../../hooks'

interface Props {
  faqHTML: string | TrustedHTML
}

const Faq: React.FC<Props> = ({ faqHTML }) => {
  const dispatch = useAppDispatch()

  const { assetBaseUrl, content } = useAppSelector((state) => state.init)
  const { isFaqModalOpen } = useAppSelector((state) => state.ui)

  return (
    <Modal
      isOpen={isFaqModalOpen}
      onAfterOpen={() => {
        // @ts-expect-error // TODO
        window.addFaqEventListener?.() // TODO: type as globally available
      }}
      onRequestClose={() => {
        dispatch(setIsFaqModalOpen(false))
      }}
      contentLabel="Vanliga frågor" // only for screenreaders
    >
      <Styled.ModalFaq assetBaseUrl={assetBaseUrl}>
        <Heading level={2}>{content.modals.faq.title}</Heading>
        <div dangerouslySetInnerHTML={{ __html: faqHTML }}></div>
      </Styled.ModalFaq>
    </Modal>
  )
}

export default Faq
